/* What Kind of Goal Seeker Are You? Question data, scoring, reading and UI.
   Source kept in the MD project (claude/goal-seeker-readings.md). Klaviyo property and metric
   names are unchanged from the Traveler version so the live nurture flow keeps triggering. */
var MDGS = (function () {
  "use strict";

  var CDN = "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/";
  var VER = "?v=1789658047";
  var READINGS = {
"C-Q-H": {
"no": "01",
"slug": "trailblazer",
"name": "The Trailblazer",
"short": "Trailblazer",
"plural": "Trailblazers",
"tagline": "Knows the destination. Already on the trail.",
"gifts_head": "When you decide, things move.",
"gifts": "You have conviction, courage and real energy. You don't wait for permission or perfect conditions, and the people around you feel braver just watching you go.",
"watch_head": "You can outrun your own map.",
"watch": "You run ahead of the plan, skip the details, and burn bright right up until you burn out. Sometimes you drift off course without noticing, because you are moving too fast to look at the compass.",
"start": "This week, pick one evening and ask a single question: is what I am doing still pointed at where I said I wanted to go? Five minutes. No overhaul.",
"motto": "Speed is a gift. Direction is what makes it count.",
"season": [
"Early spring",
"The first warm week, when everything wants to begin. Your energy matches the season. It is also your best time to pause and choose which trail deserves it."
],
"lucky": [
"A pocket watch",
"Not to rush you. To remind you that ten quiet minutes of checking direction are part of the journey, not a detour from it."
],
"superpower": [
"Momentum",
"You turn ideas into motion faster than anyone you know. Once you're pointed the right way, very little can stop you."
],
"kindred": [
"The Navigator",
"You both know where you're headed and you both move fast. Together you can get a lot done by lunch."
],
"steady": [
"The Cartographer",
"Loves the details you skip. Let them look over your route once before you set out, and you'll arrive with energy to spare."
],
"opposite": [
"The Lighthouse Keeper",
"Watches every wave before setting out. They may test your patience. They also notice the rocks you'd sail right past."
],
"tool": "The Pocket Compass",
"tool_body": "It keeps your North Star, your Momentum Goals and your MAP in your bag, so you can check your direction without slowing down. The Guidebook helps you choose the few goals truly worth all that energy.",
"forecast": "Before you sprint, check the compass. Five quiet minutes on Sunday can save a week headed the wrong way.",
"stats": [
[
"BOLD FIRST STEPS",
"●●●●●"
],
[
"TRAIL ENERGY",
"●●●●●"
],
[
"PAUSE AND CHECK",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-01-trailblazer.png?v=1789658047"
},
"C-Q-M": {
"no": "02",
"slug": "navigator",
"name": "The Navigator",
"short": "Navigator",
"plural": "Navigators",
"tagline": "Clear course, charted route, full steam ahead.",
"gifts_head": "You see things through.",
"gifts": "You are organized, driven and reliable. You can hold a big plan in your head and still remember the small promise you made on Tuesday. People trust you to get there.",
"watch_head": "A full plan can crowd out the reason.",
"watch": "You can carry too many goals at once and fill every hour. When one week goes sideways, it can feel like the whole plan failed. Somewhere in the schedule, the reason you started gets a little quieter.",
"start": "Look at next week and leave one block completely unplanned. Call it the shift block. If something breaks, that is where it gets fixed, and nothing else has to fall.",
"motto": "A good navigator adjusts the sails. The destination stays the same.",
"season": [
"Late summer",
"Long, steady days with the year still full of possibility. It is the perfect time for your favorite thing: a good plan with a little room in it."
],
"lucky": [
"A pencil with an eraser",
"Your plans are excellent. They are also allowed to change. Keep one close as a reminder that adjusting isn't failing."
],
"superpower": [
"Follow-through",
"You finish what you start, and you make it look calm. That is rarer than you think."
],
"kindred": [
"The Trailblazer",
"Same clear destination, same get-it-done energy. They move by instinct, you move by plan, and it works."
],
"steady": [
"The Homebody",
"Knows exactly what matters and never rushes it. Spend an unhurried afternoon with them and you'll remember your why."
],
"opposite": [
"The Stargazer",
"Still choosing which star to follow, and in no hurry about it. They may drive you a little crazy. They are also brilliant at the question you skip: what is all of this for?"
],
"tool": "The Compass Guidebook",
"tool_body": "The Guidebook's North Star work is the why underneath your plan. The Compass Planner then gives you a weekly rhythm of Plan, Do, Review and Shift, so adjusting is built in rather than treated as failure.",
"forecast": "Leave one afternoon open. A plan that can bend is a plan that lasts.",
"stats": [
[
"PLANNING SKILLS",
"●●●●●"
],
[
"FOLLOW-THROUGH",
"●●●●○"
],
[
"ROOM TO BEND",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-02-navigator.png?v=1789658047"
},
"C-L-M": {
"no": "03",
"slug": "cartographer",
"name": "The Cartographer",
"short": "Cartographer",
"plural": "Cartographers",
"tagline": "Maps every road before taking the first step.",
"gifts_head": "Nobody sees the details the way you do.",
"gifts": "You are thoughtful, thorough and prepared. You think things through before you speak, and when you finally commit, your plan is usually the best one in the room.",
"watch_head": "Planning can quietly become the project.",
"watch": "Waiting for the perfect plan can look a lot like preparation. Weeks pass with a beautiful map and no miles on it.",
"start": "Take one thing you have been planning and do the smallest first step today, before the plan is finished. Then write down one thing the step taught you that the plan could not.",
"motto": "The map is ready enough. The road will teach you the rest.",
"season": [
"Deep winter",
"Quiet evenings, a warm lamp, time to think. Your favorite season for dreaming up the plan. Just promise yourself one small step before spring."
],
"lucky": [
"A fine-point pen",
"Use it for one thing only this week: crossing off a first step you took before you felt ready."
],
"superpower": [
"Foresight",
"You see the turns in the road long before anyone else does. When you share what you see, people get where they're going with fewer wrong turns."
],
"kindred": [
"The Homebody",
"You both know what matters and you both like to take your time. A cozy, thoughtful friendship."
],
"steady": [
"The Trailblazer",
"Starts before the map is dry. A little of their courage and a little of your care make a very good trip."
],
"opposite": [
"The Adventurer",
"Says yes to every road without checking the map. They'll make you nervous. They'll also show you how much you can learn by simply beginning."
],
"tool": "The Compass Planner",
"tool_body": "Plan. Do. Repeat. For you, the Do is the whole point. The Guidebook's MAP (your Motivated Action Plan) turns careful planning into first steps you can actually take.",
"forecast": "Your map is ready enough. Take one small step before Wednesday.",
"stats": [
[
"ATTENTION TO DETAIL",
"●●●●●"
],
[
"THOUGHTFUL PLANS",
"●●●●●"
],
[
"FIRST STEPS",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-03-cartographer.png?v=1789658047"
},
"C-L-H": {
"no": "04",
"slug": "homebody",
"name": "The Homebody",
"short": "Homebody",
"plural": "Homebodies",
"tagline": "Knows exactly what matters. Happiest close to home.",
"gifts_head": "You know how to be content.",
"gifts": "You are grounded, loyal and deeply aware of what matters. You don't chase every shiny thing, and the people you love feel it.",
"watch_head": "Someday can become the plan.",
"watch": "Comfort can outweigh change, and it is easy to wait for life to calm down first. The things you care about most can stay in the someday pile a little too long.",
"start": "Choose one small change that fits inside the life you already love. Not a reinvention. One small, meaningful step you could take from your favorite chair.",
"motto": "You don't have to leave home to go somewhere new.",
"season": [
"Autumn",
"Soft sweaters, a full kitchen, the lights on early. You are at your best when life slows down, which makes autumn a lovely time to take one small, cozy step."
],
"lucky": [
"A favorite mug",
"Pair one small step with the cup you already love. Coffee first, then five minutes on the thing that matters."
],
"superpower": [
"Knowing what matters",
"Other people spend years figuring out what you already know. That is a head start, not a slow start."
],
"kindred": [
"The Cartographer",
"You both know what matters and like to take your time. Put the kettle on and you could talk for hours."
],
"steady": [
"The Navigator",
"Already on the move with a plan in hand. Borrow a little of their momentum and your someday gets a date."
],
"opposite": [
"The Collector",
"Starting fresh every month with a new planner. They may make you tired just watching. They also remember how exciting a beginning can be."
],
"tool": "The Compass Guidebook",
"tool_body": "The Guidebook's Momentum Goals and MAP turn what you care about into a few small, meaningful steps, not an upheaval. The Pocket Compass is a gentle daily reminder of where you are headed.",
"forecast": "Choose one small change you can make without leaving the life you love.",
"stats": [
[
"KNOWING WHAT MATTERS",
"●●●●●"
],
[
"LOYALTY",
"●●●●●"
],
[
"SMALL NEW STEPS",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-04-homebody.png?v=1789658047"
},
"W-Q-H": {
"no": "05",
"slug": "adventurer",
"name": "The Adventurer",
"short": "Adventurer",
"plural": "Adventurers",
"tagline": "Says yes to every road. Wants to see it all.",
"gifts_head": "Starting is never the hard part.",
"gifts": "You are curious, enthusiastic and open. Ideas come easily, and your yes makes the people around you want to say yes too.",
"watch_head": "Every new road looks like the one.",
"watch": "Too many goals, scattered energy, and a trail of exciting beginnings. Every new path looks like the right one, until the next one does.",
"start": "Write down every goal you are carrying right now. Then circle the one that would make the others easier. Just for this week, that is the road.",
"motto": "You can go anywhere. You just can't go everywhere at once.",
"season": [
"Summer",
"Long days, open windows, a yes around every corner. Enjoy it, and pick the one road you'll still be glad you took in September."
],
"lucky": [
"A single index card",
"One card, one goal, this week. When something new calls, write it on the back for later."
],
"superpower": [
"Possibility",
"You see openings where other people see walls. Point that gift at one road, and watch what happens."
],
"kindred": [
"The Collector",
"You could start a garden, a book club and a side business together by Friday. Fun together. Choose one first."
],
"steady": [
"The Trailblazer",
"Same fearless energy, with a destination already picked. Watch how they say no to good roads to stay on the great one."
],
"opposite": [
"The Cartographer",
"Maps every road before taking a single step. They may seem slow to you. They also get to the end of the roads they start."
],
"tool": "The Compass Guidebook",
"tool_body": "Discover. Decide. Design. For you, Decide is where the freedom is. The Guidebook helps you choose a few Momentum Goals worth your energy, so the rest can wait without guilt.",
"forecast": "Three roads are calling. Pick one for this week and let the others wait their turn.",
"stats": [
[
"CURIOSITY",
"●●●●●"
],
[
"FRESH IDEAS",
"●●●●●"
],
[
"ONE ROAD AT A TIME",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-05-adventurer.png?v=1789658047"
},
"W-Q-M": {
"no": "06",
"slug": "collector",
"name": "The Collector",
"short": "Collector",
"plural": "Collectors",
"tagline": "Beautiful planners, fresh starts, and a shelf full of first weeks.",
"gifts_head": "You can see how life could look, and you make it beautiful.",
"gifts": "You love order and a lovely page. You are hopeful every single time you begin. You can set up a system better than anyone you know, and you never stop wanting to grow.",
"watch_head": "The setup is your favorite part.",
"watch": "By week three the shine fades, and a brand new planner starts to look like the answer. It usually isn't the planner. It's that nothing is holding your direction for you when the newness wears off.",
"start": "Before you buy or start anything new, open the last planner you used and write one sentence on the first blank page: what was I hoping this would help me do? That sentence is more useful than a fresh cover.",
"motto": "The best planner is the one that remembers where you are going.",
"season": [
"September and January",
"Fresh notebooks, sharpened pencils, a clean first page. These are your favorite days of the year, and your best time to choose a direction worth keeping."
],
"lucky": [
"A bookmark",
"It holds your place, so you never have to start over. Keep one in whatever you are working in right now."
],
"superpower": [
"Making it feel possible",
"Your hope is contagious. When you set something up, other people want to begin too."
],
"kindred": [
"The Adventurer",
"You two could start a garden, a book club and a side business by Friday. Fun together. Choose one first."
],
"steady": [
"The Navigator",
"Loves order as much as you do and already knows where it is headed. Borrow their why."
],
"opposite": [
"The Homebody",
"Knows what matters and is in no hurry at all. They may drive you a little crazy. Watch how long they stay with one thing."
],
"tool": "The Pocket Compass",
"tool_body": "Small enough to carry everywhere. It keeps your direction in front of you on day forty, long after the new-planner feeling is gone. The whole Compass Kit works as one system, and this is the piece that helps a Collector stay.",
"forecast": "No new notebooks this week. Open the one you already have to the page where you left off.",
"stats": [
[
"SETUP SKILLS",
"●●●●●"
],
[
"FRESH START ENERGY",
"●●●●●"
],
[
"DAY FORTY GRIT",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-06-collector.png?v=1789658047"
},
"W-L-M": {
"no": "07",
"slug": "lighthouse-keeper",
"name": "The Lighthouse Keeper",
"short": "Lighthouse Keeper",
"plural": "Lighthouse Keepers",
"tagline": "Watches every wave. Waits for clear skies.",
"gifts_head": "You notice what others miss.",
"gifts": "You are careful, perceptive and wise. You see risks early, you think before you leap, and people come to you when they need an honest second look.",
"watch_head": "Waiting for certainty can keep you on shore.",
"watch": "Overthinking, researching instead of deciding, waiting to be sure. The fear of choosing wrong can quietly become the reason nothing gets chosen.",
"start": "Pick one decision you have been circling. Give yourself a deadline this week and a rule: my first answer does not have to be my final answer.",
"motto": "Clear skies are rare. A steady light is enough to set out.",
"season": [
"Spring rain",
"Soft grey mornings when the world is quiet and growing. You don't need sunshine to begin. A gentle, steady start suits you perfectly."
],
"lucky": [
"A lantern",
"It only lights the next few steps. That is all you need to walk forward."
],
"superpower": [
"Wisdom",
"You weigh things carefully and see what others rush past. When you do decide, it is usually a very good decision."
],
"kindred": [
"The Stargazer",
"Two thoughtful souls who like to take their time. You'll have the best long talks, and one of you should suggest a first step."
],
"steady": [
"The Cartographer",
"Just as careful as you, and already knows where they're headed. Watch how they turn careful thinking into a plan with a start date."
],
"opposite": [
"The Trailblazer",
"Leaps first, looks later. They'll make you nervous. They'll also show you that most first steps can be undone."
],
"tool": "The Compass Guidebook",
"tool_body": "It moves at a calm, guided pace, one step at a time. And it is built on an idea made for you: your first answer does not have to be your final answer.",
"forecast": "Stop researching by Thursday. Decide with what you know. Your first answer can change.",
"stats": [
[
"CAREFUL THINKING",
"●●●●●"
],
[
"SEEING WHAT OTHERS MISS",
"●●●●●"
],
[
"DECIDING",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-07-lighthouse-keeper.png?v=1789658047"
},
"W-L-H": {
"no": "08",
"slug": "stargazer",
"name": "The Stargazer",
"short": "Stargazer",
"plural": "Stargazers",
"tagline": "Big dreams, a wide sky, and still choosing which star to follow.",
"gifts_head": "You see possibility everywhere.",
"gifts": "You are imaginative, reflective and hopeful. You ask the big questions other people are too busy to ask, and you dream in full color.",
"watch_head": "A dream without a path can drift.",
"watch": "Waiting for inspiration, dreaming without a first step, and not quite knowing where to begin. The sky is wide, so choosing one star can feel like giving up the others.",
"start": "Tonight, finish this sentence three different ways: a year from now, I would love my ordinary Tuesday to feel like... Notice which one you keep thinking about.",
"motto": "Wonder is where direction begins.",
"season": [
"Clear winter nights",
"Cold air, a wide dark sky, every star visible. Your season for big questions. Write down the answer that makes your heart beat faster."
],
"lucky": [
"A notebook by the bed",
"Your best ideas show up at night. Catch them, then pick one to take a step on in the morning."
],
"superpower": [
"Imagination",
"You can picture a life that doesn't exist yet. That is exactly where every real change begins."
],
"kindred": [
"The Lighthouse Keeper",
"Two thoughtful souls who like to take their time. You'll share big ideas late into the evening."
],
"steady": [
"The Homebody",
"Just as unhurried as you, and already knows what matters most. Ask them how they knew."
],
"opposite": [
"The Navigator",
"Has the whole route planned and a calendar to prove it. They may overwhelm you a little. They are also wonderful at turning a dream into Tuesday."
],
"tool": "The Compass Guidebook",
"tool_body": "It starts right where you do: your North Star and your Dream Life. The Guidebook is designed to turn wonder into direction, one gentle step at a time.",
"forecast": "Write down one dream, then one first step beneath it. Wonder is where direction begins.",
"stats": [
[
"IMAGINATION",
"●●●●●"
],
[
"BIG QUESTIONS",
"●●●●●"
],
[
"FIRST STEPS",
"●●○○○  growing"
]
],
"card": "https://cdn.shopify.com/s/files/1/0268/1815/0479/files/goal-seeker-08-stargazer.png?v=1789658047"
}
};

  var SCALE = [
    { v: 1, word: "Not me" }, { v: 2, word: "A little" }, { v: 3, word: "Somewhat" },
    { v: 4, word: "Mostly" }, { v: 5, word: "Very me" }
  ];

  var AREAS = [
    { key: "Spirituality", idea: "Grounding", t: "Feeling grounded and at peace" },
    { key: "Health", idea: "Ownership", t: "Energy, body and mind" },
    { key: "Wealth", idea: "Freedom", t: "Money and a sense of freedom" },
    { key: "Relationships", idea: "Connection", t: "The people who matter most" },
    { key: "Environment", idea: "Support", t: "Home and the spaces you spend time in" },
    { key: "Purpose", idea: "Fulfillment", t: "Work, contribution and doing what lights you up" }
  ];

  var STEPS = [
    {
      eyebrow: "Chapter one", title: "Your direction", sub: "How clear the destination feels right now.",
      q: [
        { id: "d1", kind: "scale", axis: "D", text: "If someone asked what I want my life to feel like in five years, I could answer without much hesitation." },
        { id: "d2", kind: "pair", axis: "D", text: "Which sounds more like you?", options: [
          { t: "I know what I want. I just need to get there.", s: 2 },
          { t: "I'm not sure the goals I'm chasing are the right ones.", s: -2 } ] },
        { id: "d3", kind: "choice", axis: "D", text: "It's New Year's Day and you sit down with your goals. The list looks like:", options: [
          { t: "Short, and much like last year's, because those things still matter.", s: 2 },
          { t: "A few clear goals, sharpened a bit.", s: 1 },
          { t: "Long, with a little of everything.", s: -1 },
          { t: "Mostly blank. I'm not sure what to write.", s: -2 } ] },
        { id: "d4", kind: "rscale", axis: "D", text: "I sometimes wonder if I'm working hard on the wrong things." },
        { id: "d5", kind: "picture", axis: "D", text: "Which picture feels most like your goals right now?", options: [
          { t: "A mountain peak with a clear trail", icon: "peak", s: 2 },
          { t: "A harbor town on the horizon", icon: "harbor", s: 1 },
          { t: "A signpost pointing every way", icon: "signpost", s: -1 },
          { t: "Open sea, no land in sight", icon: "sea", s: -2 } ] }
      ]
    },
    {
      eyebrow: "Chapter two", title: "How you begin", sub: "What happens between the idea and the first step.",
      q: [
        { id: "s1", kind: "scale", axis: "S", text: "When a new idea excites me, I usually start on it that same day." },
        { id: "s2", kind: "pair", axis: "S", text: "Which sounds more like you?", options: [
          { t: "Beginnings come easily. Finishing is harder.", s: 2 },
          { t: "Starting is the hardest part. Once I'm going, I keep going.", s: -2 } ] },
        { id: "s3", kind: "choice", axis: "S", text: "You bring home a beautiful new planner. What happens next?", options: [
          { t: "I set it up that night.", s: 2 },
          { t: "I start within a day or two.", s: 1 },
          { t: "I save it for a fresh start, like a Monday or the first of the month.", s: -1 },
          { t: "It waits on the shelf until life calms down.", s: -2 } ] },
        { id: "s4", kind: "rscale", axis: "S", text: "I wait until I feel ready before I begin something important." },
        { id: "s5", kind: "choice", axis: "S", text: "Something important is due in two weeks. You:", options: [
          { t: "Start today.", s: 2 },
          { t: "Sketch a plan and begin in a few days.", s: 1 },
          { t: "Think about it a lot and start in the final week.", s: -1 },
          { t: "Do most of it the night before.", s: -2 } ] }
      ]
    },
    {
      eyebrow: "Chapter three", title: "How you plan", sub: "Step by step, or a point on the horizon.",
      q: [
        { id: "t1", kind: "scale", axis: "T", text: "I enjoy the details: checklists, color-coding, getting the layout just right." },
        { id: "t2", kind: "pair", axis: "T", text: "Which sounds more like you?", options: [
          { t: "Show me every step, in order.", s: 2 },
          { t: "Point me in the right direction. I'll figure out the rest.", s: -2 } ] },
        { id: "t3", kind: "choice", axis: "T", text: "You're hosting a birthday dinner at home. You:", options: [
          { t: "Use a checklist I've refined over the years.", s: 2 },
          { t: "Make a list the night before.", s: 1 },
          { t: "Pick up the essentials and keep it simple.", s: -1 },
          { t: "Figure it out as people arrive.", s: -2 } ] },
        { id: "t4", kind: "rscale", axis: "T", text: "Detailed plans make me feel boxed in." },
        { id: "t5", kind: "picture", axis: "T", text: "Which would you rather keep on your desk?", options: [
          { t: "A notebook with every step written out", icon: "notebook", s: 2 },
          { t: "A tidy weekly list", icon: "list", s: 1 },
          { t: "A sticky note with one word on it", icon: "sticky", s: -1 },
          { t: "A photo of the life you want", icon: "photo", s: -2 } ] }
      ]
    },
    {
      eyebrow: "Chapter four", title: "Your fuel and staying power", sub: "Where your energy is, and what usually happens next.",
      q: [
        { id: "g1", kind: "choice", gauge: "F", text: "Right now, how's your energy for the things you'd like to change?", options: [
          { t: "Running on fumes", s: 1 }, { t: "Low, but it's there", s: 2 }, { t: "Steady", s: 3 }, { t: "Full tank, ready to go", s: 4 } ] },
        { id: "g2", kind: "scale", gauge: "F", text: "I feel hopeful that this year can be different." },
        { id: "g3", kind: "choice", gauge: "P", text: "Think about the last goal you set. What happened?", options: [
          { t: "Never quite got started", s: 1 }, { t: "Started strong, stopped within a few weeks", s: 2 },
          { t: "Made real progress, then it faded", s: 3 }, { t: "Saw it through", s: 4 } ] },
        { id: "g4", kind: "choice", gauge: "P", text: "When a plan falls apart for a week, you usually:", options: [
          { t: "Let it go for good", s: 1 }, { t: "Feel guilty and avoid it for a while", s: 2 },
          { t: "Wait and start over fresh next Monday", s: 3 }, { t: "Pick up where I left off", s: 4 } ] }
      ]
    },
    {
      eyebrow: "Chapter five", title: "What's asking for attention", sub: "No scores here. Just where your attention keeps drifting.",
      q: [
        { id: "p1", kind: "pick2", text: "Which parts of life are asking for the most attention right now? Choose up to two.",
          options: AREAS.map(function (a) { return { t: a.key, d: a.t, v: a.key }; }),
          none: "Nothing is really off. I just want more direction." },
        { id: "p2", kind: "choice", text: "Which of these sounds most like you lately?", options: [
          { t: "“I don't know which goals actually matter.”", v: "I don't know which goals actually matter." },
          { t: "“I start over every month.”", v: "I start over every month." },
          { t: "“My planner fills up with tasks but not progress.”", v: "My planner fills up with tasks but not progress." },
          { t: "“I lose sight of the big picture.”", v: "I lose sight of the big picture." },
          { t: "“I feel overwhelmed.”", v: "I feel overwhelmed." } ] },
        { id: "p3", kind: "choice", compact: true, text: "A year from now, what would you most love to feel?", options: [
          { t: "Clarity", v: "Clarity" }, { t: "Peace", v: "Peace" }, { t: "Progress", v: "Progress" },
          { t: "Consistency", v: "Consistency" }, { t: "Confidence", v: "Confidence" }, { t: "Hope", v: "Hope" } ] }
      ]
    },
    {
      eyebrow: "Chapter six", title: "Your story so far", sub: "Two last questions.",
      q: [
        { id: "j1", kind: "choice", compact: true, text: "How many planners or goal systems have you tried in the last few years?", options: [
          { t: "None", v: "None" }, { t: "1 or 2", v: "1-2" }, { t: "3 to 5", v: "3-5" }, { t: "I've lost count", v: "Lost count" } ] },
        { id: "j2", kind: "choice", compact: true, text: "Do you make progress better on your own or with company?", options: [
          { t: "On my own", v: "Solo" }, { t: "With a friend or partner", v: "Friend or partner" }, { t: "With a group", v: "Group" } ] }
      ]
    }
  ];

  function allQuestions() { var out = []; STEPS.forEach(function (st) { st.q.forEach(function (q) { out.push(q); }); }); return out; }
  function find(id) { var qs = allQuestions(); for (var i = 0; i < qs.length; i++) if (qs[i].id === id) return qs[i]; return null; }
  function isAnswered(q, a) { var v = a[q.id]; if (q.kind === "pick2") return Array.isArray(v) && v.length > 0; return v !== undefined && v !== null; }
  function itemScore(q, v) { if (q.kind === "scale") return v - 3; if (q.kind === "rscale") return 3 - v; return q.options[v].s; }
  function axisScore(axis, a) {
    var total = 0;
    allQuestions().forEach(function (q) { if (q.axis === axis && isAnswered(q, a)) total += itemScore(q, a[q.id]); });
    if (total === 0) {
      var pair = null;
      allQuestions().forEach(function (q) { if (q.axis === axis && q.kind === "pair") pair = q; });
      if (pair && isAnswered(pair, a)) return { score: 0, plus: pair.options[a[pair.id]].s > 0 };
    }
    return { score: total, plus: total > 0 };
  }
  function cardUrl(t) { return CDN + "goal-seeker-" + t.no + "-" + t.slug + ".png" + VER; }

  function compute(a) {
    var D = axisScore("D", a), S = axisScore("S", a), T = axisScore("T", a);
    var code = (D.plus ? "C" : "W") + "-" + (S.plus ? "Q" : "L") + "-" + (T.plus ? "M" : "H");
    var t = READINGS[code];
    var axes = [{ k: 0, s: D }, { k: 1, s: S }, { k: 2, s: T }];
    var weakest = axes.slice().sort(function (x, y) { return Math.abs(x.s.score) - Math.abs(y.s.score); })[0];
    var secondary = "";
    if (Math.abs(weakest.s.score) < 6) {
      var parts = code.split("-");
      var flip = { C: "W", W: "C", Q: "L", L: "Q", M: "H", H: "M" };
      parts[weakest.k] = flip[parts[weakest.k]];
      secondary = READINGS[parts.join("-")].name;
    }
    function strength(x) { return Math.abs(x.score) >= 6 ? "Strongly" : "Leans"; }
    var fuelRaw = (a.g1 !== undefined ? find("g1").options[a.g1].s : 0) + (a.g2 || 0);
    var fuel = fuelRaw <= 4 ? "Running Low" : (fuelRaw <= 7 ? "Steady" : "Full Tank");
    var stayRaw = (a.g3 !== undefined ? find("g3").options[a.g3].s : 0) + (a.g4 !== undefined ? find("g4").options[a.g4].s : 0);
    var staying = stayRaw <= 4 ? "Often Stalls" : (stayRaw <= 6 ? "Stops and Starts" : "Keeps Going");
    var pinch = Array.isArray(a.p1) ? a.p1.slice(0, 2) : [];
    if (pinch.length === 1 && pinch[0] === "none") pinch = [];
    function idea(k) { for (var i = 0; i < AREAS.length; i++) if (AREAS[i].key === k) return AREAS[i].idea; return ""; }
    function val(id) { var q = find(id); return a[id] !== undefined ? q.options[a[id]].v : ""; }
    return {
      code: code, reading: t, type: t.name, tagline: t.tagline, line: t.motto, tool: t.tool, card: cardUrl(t),
      secondary: secondary,
      direction: { score: D.score, pole: D.plus ? "Destination Set" : "Still Wandering", strength: strength(D) },
      starting: { score: S.score, pole: S.plus ? "Quick Start" : "Slow Start", strength: strength(S) },
      detail: { score: T.score, pole: T.plus ? "Map Keeper" : "Horizon Seeker", strength: strength(T) },
      fuel: fuel, staying: staying,
      pinch1: pinch[0] || "None", pinch1Idea: pinch[0] ? idea(pinch[0]) : "",
      pinch2: pinch[1] || "", pinch2Idea: pinch[1] ? idea(pinch[1]) : "",
      painPhrase: val("p2"), desire: val("p3"), plannerCount: val("j1"), company: val("j2"),
      careNote: fuel === "Running Low" && pinch.indexOf("Health") !== -1
    };
  }
  function properties(r) {
    var P = "LifeAssessment_", o = {};
    o[P + "Version"] = "Goal Seeker v2";
    o[P + "Type"] = r.type;
    o[P + "TypeCode"] = r.code;
    o[P + "TypeNo"] = r.reading.no;
    o[P + "TypeTagline"] = r.tagline;
    o[P + "TypeLine"] = r.line;
    o[P + "TypeTool"] = r.tool;
    o[P + "TypeCard"] = r.card;
    o[P + "TypeSecondary"] = r.secondary;
    var t = r.reading;
    o[P + "TypeShort"] = t.short;
    o[P + "TypePlural"] = t.plural;
    o[P + "TypeGiftsHead"] = t.gifts_head;
    o[P + "TypeGifts"] = t.gifts;
    o[P + "TypeWatchHead"] = t.watch_head;
    o[P + "TypeWatch"] = t.watch;
    o[P + "TypeStart"] = t.start;
    o[P + "TypeSeason"] = t.season[0];
    o[P + "TypeSeasonBody"] = t.season[1];
    o[P + "TypeLucky"] = t.lucky[0];
    o[P + "TypeLuckyBody"] = t.lucky[1];
    o[P + "TypeSuperpower"] = t.superpower[0];
    o[P + "TypeSuperpowerBody"] = t.superpower[1];
    o[P + "TypeKindred"] = t.kindred[0];
    o[P + "TypeKindredBody"] = t.kindred[1];
    o[P + "TypeSteady"] = t.steady[0];
    o[P + "TypeSteadyBody"] = t.steady[1];
    o[P + "TypeOpposite"] = t.opposite[0];
    o[P + "TypeOppositeBody"] = t.opposite[1];
    o[P + "TypeToolBody"] = t.tool_body;
    o[P + "TypeForecast"] = t.forecast;
    o[P + "Direction"] = r.direction.pole;
    o[P + "DirectionScore"] = r.direction.score;
    o[P + "StartingStyle"] = r.starting.pole;
    o[P + "StartingStyleScore"] = r.starting.score;
    o[P + "Detail"] = r.detail.pole;
    o[P + "DetailScore"] = r.detail.score;
    o[P + "Fuel"] = r.fuel;
    o[P + "StayingPower"] = r.staying;
    o[P + "Pinch1"] = r.pinch1;
    o[P + "Pinch1Idea"] = r.pinch1Idea;
    o[P + "Pinch2"] = r.pinch2;
    o[P + "Pinch2Idea"] = r.pinch2Idea;
    o[P + "PainPhrase"] = r.painPhrase;
    o[P + "Desire"] = r.desire;
    o[P + "PlannerCount"] = r.plannerCount;
    o[P + "Company"] = r.company;
    o[P + "Date"] = new Date().toISOString();
    return o;
  }
  return { SCALE: SCALE, STEPS: STEPS, READINGS: READINGS, AREAS: AREAS, allQuestions: allQuestions, isAnswered: isAnswered, compute: compute, properties: properties, cardUrl: cardUrl };
})();

(function () {
  "use strict";
  var root = document.querySelector(".md-gs");
  if (!root || root.dataset.gsInit === "1") return;
  root.dataset.gsInit = "1";

  var cfg = window.MD_LA_CONFIG || {};
  var STORE = "md_goal_seeker_v2";
  var answers = {}, step = 0, lastResult = null, lastName = "";
  var $ = function (id) { return document.getElementById(id); };
  var screens = { intro: $("gs-intro"), quiz: $("gs-quiz"), capture: $("gs-capture"), envelope: $("gs-envelope"), reading: $("gs-reading") };
  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = k !== name; });
    root.scrollIntoView({ block: "start" });
  }

  var ICONS = {
    peak: '<path d="M4 40 L20 14 L27 25 L32 18 L44 40 Z"/><path d="M20 14 V6 L26 8 L20 10"/><path d="M14 40 C18 34 22 34 24 30 C26 26 30 26 31 22" stroke-dasharray="2 3"/>',
    harbor: '<path d="M4 34 H44"/><path d="M8 34 V26 H14 V34 M16 34 V22 H24 V34 M26 34 V27 H32 V34"/><path d="M36 34 V16 M36 16 L42 20 L36 22"/><path d="M4 40 C10 37 14 43 20 40 C26 37 30 43 36 40 C40 38 42 39 44 40"/>',
    signpost: '<path d="M24 8 V42"/><path d="M24 12 H38 L42 15 L38 18 H24"/><path d="M24 22 H10 L6 25 L10 28 H24"/><path d="M24 30 H36 L40 33 L36 36 H24"/><path d="M16 42 H32"/>',
    sea: '<path d="M4 22 H44" stroke-dasharray="1 3"/><path d="M4 30 C10 27 14 33 20 30 C26 27 30 33 36 30 C40 28 42 29 44 30"/><path d="M4 38 C10 35 14 41 20 38 C26 35 30 41 36 38 C40 36 42 37 44 38"/><circle cx="34" cy="13" r="4"/>',
    notebook: '<rect x="12" y="6" width="26" height="36" rx="2"/><path d="M12 6 V42"/><path d="M18 14 H33 M18 20 H33 M18 26 H33 M18 32 H28"/><path d="M8 12 H14 M8 20 H14 M8 28 H14 M8 36 H14"/>',
    list: '<rect x="10" y="8" width="28" height="34" rx="2"/><path d="M16 17 L18 19 L22 15 M16 26 L18 28 L22 24 M16 35 H22"/><path d="M25 17 H33 M25 26 H33 M25 35 H33"/>',
    sticky: '<path d="M10 10 H38 V30 L30 38 H10 Z"/><path d="M38 30 H30 V38"/><path d="M16 22 C19 19 22 25 26 21"/>',
    photo: '<rect x="8" y="10" width="32" height="30" rx="1"/><rect x="12" y="14" width="24" height="18"/><path d="M12 30 L20 22 L25 27 L29 23 L36 30"/><circle cx="30" cy="18" r="2"/>'
  };

  function save() { try { localStorage.setItem(STORE, JSON.stringify({ a: answers, s: step })); } catch (e) {} }
  function clear() { try { localStorage.removeItem(STORE); } catch (e) {} }
  function load() {
    try { var raw = localStorage.getItem(STORE); if (!raw) return; var d = JSON.parse(raw); if (d && d.a) { answers = d.a; step = d.s || 0; } }
    catch (e) { answers = {}; step = 0; }
  }

  var ALL = MDGS.allQuestions();
  var LETTERS = "ABCDEFG";
  function answeredCount() { return ALL.filter(function (q) { return MDGS.isAnswered(q, answers); }).length; }
  function progress() {
    var pct = Math.round(answeredCount() / ALL.length * 100);
    $("gs-progpct").textContent = pct + "%";
    $("gs-progfill").style.width = pct + "%";
    $("gs-progpin").style.left = pct + "%";
  }
  function stepComplete() { return MDGS.STEPS[step].q.every(function (q) { return MDGS.isAnswered(q, answers); }); }
  function refreshNext() { $("gs-next").disabled = !stepComplete(); }
  function changed() { save(); refreshNext(); progress(); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text !== undefined) n.textContent = text; return n; }
  function qNum(id) { for (var i = 0; i < ALL.length; i++) if (ALL[i].id === id) return i + 1; return 0; }

  function renderScale(q, fs) {
    var wrap = el("div", "gs-scale");
    MDGS.SCALE.forEach(function (o) {
      var id = "gs_" + q.id + "_" + o.v;
      var inp = el("input"); inp.type = "radio"; inp.name = q.id; inp.id = id; inp.value = o.v;
      if (answers[q.id] === o.v) inp.checked = true;
      inp.addEventListener("change", function () { answers[q.id] = o.v; changed(); });
      var lab = el("label"); lab.setAttribute("for", id);
      lab.appendChild(el("span", "gs-num", String(o.v)));
      lab.appendChild(el("span", "gs-word", o.word));
      wrap.appendChild(inp); wrap.appendChild(lab);
    });
    fs.appendChild(wrap);
  }
  function renderOptions(q, fs) {
    var cls = "gs-opts";
    if (q.kind === "pair") cls += " gs-pair";
    if (q.kind === "picture") cls += " gs-pics";
    if (q.compact) cls += " gs-compact";
    var wrap = el("div", cls);
    q.options.forEach(function (o, i) {
      var id = "gs_" + q.id + "_" + i;
      var inp = el("input"); inp.type = "radio"; inp.name = q.id; inp.id = id; inp.value = i;
      if (answers[q.id] === i) inp.checked = true;
      inp.addEventListener("change", function () { answers[q.id] = i; changed(); });
      var lab = el("label", "gs-opt"); lab.setAttribute("for", id);
      if (q.kind === "picture") {
        var ic = el("span", "gs-icon");
        ic.innerHTML = '<svg viewBox="0 0 48 48" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + ICONS[o.icon] + "</svg>";
        lab.appendChild(ic);
      } else if (!q.compact) {
        lab.appendChild(el("span", "gs-letter", q.kind === "pair" ? (i === 0 ? "This" : "Or") : LETTERS.charAt(i)));
      }
      lab.appendChild(el("span", "gs-opt-t", o.t));
      wrap.appendChild(inp); wrap.appendChild(lab);
    });
    fs.appendChild(wrap);
  }
  function renderPick2(q, fs) {
    var wrap = el("div", "gs-opts gs-areas"), boxes = [];
    function sync() {
      var sel = Array.isArray(answers[q.id]) ? answers[q.id] : [];
      boxes.forEach(function (b) {
        b.inp.checked = sel.indexOf(b.v) !== -1;
        b.inp.disabled = b.v !== "none" && sel.indexOf(b.v) === -1 && sel.length >= 2 && sel.indexOf("none") === -1;
      });
    }
    function toggle(v, on) {
      var sel = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
      if (v === "none") sel = on ? ["none"] : [];
      else {
        sel = sel.filter(function (x) { return x !== "none"; });
        if (on && sel.indexOf(v) === -1 && sel.length < 2) sel.push(v);
        if (!on) sel = sel.filter(function (x) { return x !== v; });
      }
      answers[q.id] = sel; sync(); changed();
    }
    q.options.concat([{ t: q.none, v: "none" }]).forEach(function (o, i) {
      var id = "gs_" + q.id + "_" + i;
      var inp = el("input"); inp.type = "checkbox"; inp.id = id;
      inp.addEventListener("change", function () { toggle(o.v, inp.checked); });
      var lab = el("label", "gs-opt" + (o.v === "none" ? " gs-none" : "")); lab.setAttribute("for", id);
      lab.appendChild(el("span", "gs-opt-t", o.t));
      if (o.d) lab.appendChild(el("span", "gs-opt-d", o.d));
      boxes.push({ inp: inp, v: o.v });
      wrap.appendChild(inp); wrap.appendChild(lab);
    });
    fs.appendChild(wrap); sync();
  }
  function render() {
    var st = MDGS.STEPS[step];
    $("gs-chapter").textContent = st.eyebrow;
    $("gs-steptitle").textContent = st.title;
    $("gs-stepsub").textContent = st.sub;
    $("gs-proglabel").textContent = "Chapter " + (step + 1) + " of " + MDGS.STEPS.length;
    progress();
    var box = $("gs-questions"); box.innerHTML = "";
    st.q.forEach(function (q) {
      var fs = el("fieldset", "gs-q"), lg = el("legend");
      lg.appendChild(el("span", "gs-qlabel", "Question " + qNum(q.id) + " of " + ALL.length));
      fs.appendChild(lg);
      fs.appendChild(el("p", "gs-qtext", q.text));
      if (q.kind === "scale" || q.kind === "rscale") renderScale(q, fs);
      else if (q.kind === "pick2") renderPick2(q, fs);
      else renderOptions(q, fs);
      box.appendChild(fs);
    });
    $("gs-back").textContent = step === 0 ? "Start over" : "Back";
    $("gs-next").textContent = step === MDGS.STEPS.length - 1 ? "Almost done" : "Next chapter";
    refreshNext();
  }

  /* ---------- The reading ---------- */
  function section(label, head, body, cls) {
    var s = el("div", "gs-block" + (cls ? " " + cls : ""));
    s.appendChild(el("p", "gs-label", label));
    if (head) s.appendChild(el("h3", "gs-h3", head));
    if (body) s.appendChild(el("p", "gs-body", body));
    return s;
  }
  function renderReading(r, fname) {
    var t = r.reading, box = $("gs-readingbody");
    box.innerHTML = "";

    var hero = el("div", "gs-hero");
    var copy = el("div", "gs-hero-copy");
    copy.appendChild(el("p", "gs-label gs-rust", (fname ? fname + ", " : "") + "here is your Goal Seeker reading"));
    copy.appendChild(el("h2", "gs-typename", "You're " + (t.short.charAt(0).match(/[AEIOU]/) ? "an " : "a ") + t.short + "."));
    if (r.secondary) copy.appendChild(el("p", "gs-script", "with a streak of " + r.secondary.replace(/^The /, "")));
    copy.appendChild(el("p", "gs-tagline", t.tagline));
    var stamps = el("div", "gs-stamps");
    [r.direction.pole, r.starting.pole, r.detail.pole].forEach(function (p) { stamps.appendChild(el("span", "gs-stamp", p)); });
    copy.appendChild(stamps);
    hero.appendChild(copy);
    var cardWrap = el("div", "gs-cardwrap");
    var img = el("img", "gs-card"); img.src = t.card || MDGS.cardUrl(t); img.alt = "Your keepsake card: " + t.name; img.width = 540; img.height = 675;
    cardWrap.appendChild(img);
    hero.appendChild(cardWrap);
    box.appendChild(hero);

    var two = el("div", "gs-two");
    two.appendChild(section("Your gifts", t.gifts_head, t.gifts, "gs-cream"));
    two.appendChild(section("Your watch-out", t.watch_head, t.watch, "gs-dashed"));
    box.appendChild(two);

    var motto = el("div", "gs-motto");
    motto.appendChild(el("p", "gs-label gs-mint", "Your motto"));
    motto.appendChild(el("p", "gs-motto-t", t.motto));
    box.appendChild(motto);

    var three = el("div", "gs-three");
    three.appendChild(section("Your season", t.season[0], t.season[1], "gs-rule"));
    three.appendChild(section("Your lucky object", t.lucky[0], t.lucky[1], "gs-rule"));
    three.appendChild(section("Your superpower", t.superpower[0], t.superpower[1], "gs-rule"));
    box.appendChild(three);

    var people = el("div", "gs-people");
    people.appendChild(el("p", "gs-label gs-rust", "Your people"));
    people.appendChild(el("h3", "gs-h2", "Who you go further with"));
    var pg = el("div", "gs-three");
    pg.appendChild(section("Your kindred spirit", t.kindred[0], t.kindred[1], "gs-cream"));
    pg.appendChild(section("Your steady friend", t.steady[0], t.steady[1], "gs-cream"));
    pg.appendChild(section("Your opposite", t.opposite[0], t.opposite[1], "gs-cream"));
    people.appendChild(pg);
    people.appendChild(el("p", "gs-script gs-center", "Send the quiz to your sister, your best friend, your partner. Then compare cards."));
    box.appendChild(people);

    var rough = el("div", "gs-rough");
    var rl = el("div", "gs-rough-l");
    rl.appendChild(el("p", "gs-label gs-rust", "What's asking for attention"));
    var areaText = r.pinch1 === "None" ? "Nothing feels badly off." : (r.pinch2 ? r.pinch1 + " and " + r.pinch2 + " are asking for you right now." : r.pinch1 + " is asking for you right now.");
    rl.appendChild(el("h3", "gs-h3", areaText));
    rough.appendChild(rl);
    var rr = el("div", "gs-rough-r");
    if (r.painPhrase) { var said = el("p", "gs-body"); said.appendChild(document.createTextNode("You told us: ")); said.appendChild(el("em", "", "“" + r.painPhrase + "”")); rr.appendChild(said); }
    rr.appendChild(el("p", "gs-body", "For " + t.plural + ", that usually isn't a willpower problem. It's a direction problem. When you know what you're going toward, the next step gets a lot easier to see."));
    rough.appendChild(rr);
    box.appendChild(rough);

    var start = el("div", "gs-start");
    start.appendChild(el("p", "gs-label gs-mint", "One place to start this week"));
    start.appendChild(el("p", "gs-start-t", t.start));
    box.appendChild(start);

    var tool = el("div", "gs-tool");
    tool.appendChild(el("p", "gs-label gs-mint2", "Your signature tool"));
    tool.appendChild(el("h3", "gs-h2", t.tool));
    var taglines = { "The Compass Guidebook": "Discover. Decide. Design.", "The Pocket Compass": "Remember. Review. Realign.", "The Compass Planner": "Plan. Do. Repeat." };
    tool.appendChild(el("p", "gs-label gs-rust", taglines[t.tool] || ""));
    tool.appendChild(el("p", "gs-body", t.tool_body));
    var kit = el("a", "gs-btn", "Meet The Compass Kit"); kit.href = "/pages/coming-soon";
    tool.appendChild(kit);
    box.appendChild(tool);

    var fc = el("div", "gs-forecast");
    fc.appendChild(el("p", "gs-label gs-rust", "This week's Goal Forecast for " + t.plural));
    fc.appendChild(el("p", "gs-forecast-t", t.forecast));
    fc.appendChild(el("p", "gs-script", "A new forecast arrives in your inbox every week."));
    box.appendChild(fc);

    if (r.careNote) {
      var care = el("div", "gs-care");
      care.appendChild(el("p", "gs-body", "One honest note before you go. You told us your energy is running low and your health is asking for attention. That matters more than any planning system does. Talking to someone you trust, or to a professional, is a reasonable and ordinary next step. We would rather say that than sell you a book about it."));
      box.appendChild(care);
    }

    var keep = el("div", "gs-keep");
    keep.appendChild(el("h3", "gs-h2", "Keep your card."));
    keep.appendChild(el("p", "gs-body", "Tuck it in your planner, set it as your lock screen, or post it and ask your friends what kind of Goal Seeker they are."));
    var row = el("div", "gs-row");
    var dl = el("a", "gs-btn", "Save my card"); dl.href = t.card || MDGS.cardUrl(t); dl.setAttribute("download", "goal-seeker-" + t.slug + ".png"); dl.target = "_blank"; dl.rel = "noopener";
    var share = el("button", "gs-btn gs-ghost", "Share with a friend"); share.type = "button";
    share.addEventListener("click", function () {
      var url = window.location.origin + window.location.pathname;
      var text = "I'm " + (t.short.charAt(0).match(/[AEIOU]/) ? "an " : "a ") + t.short + ". What kind of Goal Seeker are you?";
      if (navigator.share) { navigator.share({ title: "What Kind of Goal Seeker Are You?", text: text, url: url }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(text + " " + url).then(function () { share.textContent = "Link copied"; }); }
    });
    row.appendChild(dl); row.appendChild(share);
    keep.appendChild(row);
    var again = el("button", "gs-quiet", "Take it again"); again.type = "button";
    again.addEventListener("click", restart);
    keep.appendChild(again);
    box.appendChild(keep);
  }

  function restart() {
    answers = {}; step = 0; clear();
    $("gs-submit").disabled = false; $("gs-submit").textContent = "Seal and send";
    $("gs-envbox").classList.remove("is-open");
    show("intro");
  }

  $("gs-start").addEventListener("click", function () { show("quiz"); render(); });
  $("gs-next").addEventListener("click", function () {
    if (!stepComplete()) return;
    if (step === MDGS.STEPS.length - 1) {
      save(); show("capture");
      if (cfg.collectPhone) {
        $("gs-phonewrap").hidden = false; $("gs-smsconsentwrap").hidden = false;
        if (cfg.smsConsentText) $("gs-smsconsenttext").textContent = cfg.smsConsentText;
      }
      return;
    }
    step++; save(); render(); root.scrollIntoView({ block: "start" });
  });
  $("gs-back").addEventListener("click", function () {
    if (step === 0) { answers = {}; clear(); show("intro"); return; }
    step--; save(); render(); root.scrollIntoView({ block: "start" });
  });
  $("gs-capback").addEventListener("click", function () { show("quiz"); render(); });
  $("gs-breakseal").addEventListener("click", function () {
    var env = $("gs-envbox");
    env.classList.add("is-open");
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setTimeout(function () { show("reading"); var h = root.querySelector(".gs-typename"); if (h) { h.setAttribute("tabindex", "-1"); h.focus({ preventScroll: true }); } }, reduce ? 0 : 900);
  });

  function subscribe(person, props) {
    if (!cfg.publicKey || !cfg.listId) return Promise.resolve({ skipped: true });
    var attrs = { email: person.email, first_name: person.fname, properties: props, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } };
    if (person.phone) { attrs.phone_number = person.phone; if (person.sms) attrs.subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } }; }
    var body = { data: { type: "subscription", attributes: { custom_source: "Traveler Assessment", profile: { data: { type: "profile", attributes: attrs } } }, relationships: { list: { data: { type: "list", id: cfg.listId } } } } };
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(cfg.publicKey), { method: "POST", headers: { "Content-Type": "application/json", revision: "2025-01-15" }, body: JSON.stringify(body) });
  }
  function track(person, props) {
    if (!cfg.publicKey) return Promise.resolve({ skipped: true });
    var body = { data: { type: "event", attributes: { properties: props, metric: { data: { type: "metric", attributes: { name: "Completed Traveler Assessment" } } }, profile: { data: { type: "profile", attributes: { email: person.email, first_name: person.fname } } } } } };
    return fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(cfg.publicKey), { method: "POST", headers: { "Content-Type": "application/json", revision: "2025-01-15" }, body: JSON.stringify(body) });
  }

  $("gs-form").addEventListener("submit", function (ev) {
    ev.preventDefault();
    var err = $("gs-err"); err.hidden = true;
    var fname = $("gs-name").value.trim(), email = $("gs-email").value.trim();
    var phoneEl = $("gs-phone"), phone = phoneEl ? phoneEl.value.trim() : "";
    var smsEl = $("gs-consent-sms"), sms = !!smsEl && smsEl.checked;
    function fail(msg, focus) { err.textContent = msg; err.hidden = false; if (focus) focus.focus(); }
    if (!fname) return fail("What should we call you?", $("gs-name"));
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return fail("That email address does not look right. Mind checking it?", $("gs-email"));
    if (!$("gs-consent-email").checked) return fail("Please tick the box so we know it is alright to email you.");
    if (phone && !sms) return fail("You have entered a number but not ticked the box to allow texts. Tick it, or clear the number.");
    if (answeredCount() < ALL.length) return fail("A question or two got skipped. Go back and finish them, then send.");

    var result = MDGS.compute(answers);
    result.reading.card = result.card;
    var props = MDGS.properties(result);
    var person = { fname: fname, email: email, phone: phone, sms: sms };
    lastResult = result; lastName = fname;
    $("gs-submit").disabled = true; $("gs-submit").textContent = "Sealing...";
    var finish = function () {
      renderReading(result, fname);
      $("gs-envto").textContent = "For " + fname;
      clear();
      show("envelope");
    };
    subscribe(person, props).then(function () { return track(person, props); }).then(finish).catch(finish);
  });

  load();
  var n = answeredCount();
  if (n > 0 && n < ALL.length) { show("quiz"); render(); }
})();